module.exports = __webpack_public_path__ + "img/015-el-salvador.10041158.svg";